import React, { lazy, Suspense, useState, useEffect } from 'react';
import parse from 'html-react-parser';
import * as api from '../utils/api';
import Header from '../components/Header';
import LoadingSpinner from '../components/LoadingSpinner';
import Contact from '../components/Contact';
import InputSelect from '../components/InputSelect';
import { TContent, TAnswers } from '../utils/types';
import Grid from '../components/Grid';

const Tooltip = lazy(() => import('../components/Tooltip'));
const Message = lazy(() => import('../components/Message'));

const ServicetjekLoebende = (props: { title: string; bookingUrl: string; hvisIngenAnbefalingUrl: string; phnNumber: string; buttonText: string; livshistorieId: string; content: any; footerTekst: string; footerTooltip: string; servicetjekUrl: string; erMedlem: boolean; survey: { currentBlock: any[] } }) => {
	const baseRoot = props.servicetjekUrl;
	const [messageData, setMessageData] = useState(null);
	const [answers, setAnswers] = useState<TAnswers[]>([]);
	const [loading, setLoading] = useState(false);
	const contactItems = { booking: false, phn: true };
	const contactInfo = { bookingUrl: props.bookingUrl, phnNumber: props.phnNumber, contactItems: { booking: true, phn: true } };

	const objdata:{[key:string]: any} = [];

	useEffect(() => {
		if (props.content.length > 0) {
			const newArray: TAnswers[] = [];
			props.content.forEach(answer => {
				if (answer.default) {
					const option = answer.options.find(x => x.value === answer.default);
					newArray.push({ inputId: answer.id, optionId: option.id, value: answer.default, label: answer.label });
				}
			});
			setAnswers(newArray);
		}
	}, []);

	props.survey.currentBlock.forEach((e: { name: string, value: string }) => {
		const { name, value } = e;
		objdata[name] = value;
	});

	const surveyTextData = {
		'title': objdata['Title'],
		'content': objdata['Content'],
		'ratings': objdata['Ratings'],
		'labelLeft': objdata['LabelLeft'],
		'labelRight': objdata['LabelRight'],
		'errorMessage': objdata['ErrorMessage'],
		'successMessage': objdata['SuccessMessage'],
		'spoergsmaalType': objdata['SpoergsmaalType'],
		'surveyType': objdata['SurveyType']
	};

	const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		setLoading(true);
		const response = await api.saveLstData(props.livshistorieId, answers);

		if (response) {
			setLoading(false);
			setMessageData(response);
			setAnswers(answers);
		}
	};

	const handleSubmitUdenAnbefaling = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		setLoading(true);
		const response = await api.saveLstData(props.livshistorieId, answers);

		if (response) {
			setLoading(false);
			window.open(props.hvisIngenAnbefalingUrl, '_blank');
		}
	};

	const showNext = answers.map((e: TAnswers) => {
		const choisenContent = props.content.find((content) => {
			if (content.id === e.inputId) {
				return content.options;
			}
		});
		const choisenOption = choisenContent.options.find((option) => {
			if (option.id === e.optionId) {
				return option.showNext;
			}
		});

		return choisenOption?.showNext;
	});

	let firstSelect = 0;
	const renderContent = props.content.map((e: TContent, i: number) => {
		const content = (
			<span key={ i }>
				{ e.type === 'text' && e.text && <>{ parse(e.text) }</> }
				{ e.type === 'select' && <InputSelect contentData={ e } answers={ answers } setAnswers={ setAnswers } centered /> }
				{ e.tooltip && <Tooltip tooltipData={ e.tooltip } /> }
			</span>
		);

		if (e.type === 'text' || e.tooltip) {
			return content;
		}

		if (e.type === 'select' && firstSelect === 0) {
			firstSelect = i;
		}

		if (props.content[firstSelect].id === e.id) {
			return content;
		}

		if (e.id && showNext.includes(e.id)) {
			return content;
		}
	});

	return (
		<Suspense fallback={ <main className="lhp-main"><section className="page grid"><LoadingSpinner /></section></main> }>
			<Header title={ props.title } baseUrl={ baseRoot } />
			<main className="lhp-main" >
				{ !messageData && (
					<Grid className="page" element="section">
						<Contact contactItems={ contactItems } bookingUrl={ props.bookingUrl } phnNumber={ props.phnNumber } matomoPhoneId={ 'link_010_dim2' } />
						{ !loading && (
							<div className="content question">
								{ renderContent }
								{ props.buttonText && answers.length == 0 && props.content.length == 1 && props.hvisIngenAnbefalingUrl &&
									<button id="knap_011_dim2" className="btn btn-primary" onClick={ handleSubmitUdenAnbefaling } >{ parse(props.buttonText) }</button> }
								{ props.buttonText && props.content.length > 1 && <button id="knap_011_dim2" className="btn btn-primary" onClick={ handleSubmit } disabled={ answers.length == 0 }>{ parse(props.buttonText) }</button> }
								<div className="page-content" >
									{ props.footerTekst && <span className="page-text" >{ parse(props.footerTekst) }</span> }
									{ props.footerTooltip && <Tooltip tooltipData={ props.footerTooltip } /> }
								</div>
							</div>
						) }
						{ loading && <LoadingSpinner /> }
					</Grid>
				) }
				{ messageData && (
					<section>
						<Message
							bookingUrl={ props.bookingUrl }
							phnNumber={ props.phnNumber }
							messageData={ messageData }
							title={ props.title }
							answers={ answers }
							erMedlem={ props.erMedlem }
							data={ messageData }
							fullData={ props.content }
							contactInfo={ contactInfo }
							surveyTextData={ surveyTextData }
							livshistorieId={ props.livshistorieId }
						/>
					</section>
				) }
			</main>
		</Suspense>
	);
};

export default ServicetjekLoebende;